import RegisterPage from "./Components/RegisterPage";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import SearchPage from "./Components/SearchPage";
import ProfilePage from "./Components/ProfilePage";
import ErrorPage from "./Components/ErrorPage";
import Home from "./Components/homePage/Home";
import Navbar from "./Components/homePage/Navbar";
import Footer from "./Components/homePage/Footer";
import EditPage from "./Components/EditPage";
import Settings from "./Components/Settings";


import "./App.css";

export default function App() {

  const router = createBrowserRouter([
    {
      path: "/register",
      element: (<><Navbar bg={"bg-gray-300"} text={"text-gray-900"} /><RegisterPage /><Footer bg={"bg-gray-300"} text={"text-gray-900"} /></>),
    },
    {
      path: "/",
      element: (<><Navbar bg={"bg-gray-300"} text={"text-gray-900"} /><Home /><Footer bg={"bg-gray-300"} text={"text-gray-900"} /></>),
    },
    {
      path: "/search",
      element: (<><Navbar bg={"bg-slate-900"} text={"text-gray-300"} /><SearchPage /><Footer bg={"bg-slate-900"} text={"text-gray-300"} /></>),
    },

    {
      path: "/profile/:id",
      element: (<><Navbar bg={"bg-gray-300"} text={"text-gray-900"} /><ProfilePage /><Footer bg={"bg-gray-300"} text={"text-gray-900"} /></>),
    },
    {
      path: "/edit/:id",
      element: (<><Navbar bg={"bg-gray-300"} text={"text-gray-900"} /><EditPage /><Footer bg={"bg-gray-300"} text={"text-gray-900"} /></>),
    },
    {
      path: "/settings",
      element: (<Settings />),
    },
    {
      path: "/*",
      element: (<><Navbar bg={"bg-slate-900"} text={"text-gray-300"} /> <ErrorPage /><Footer bg={"bg-slate-900"} text={"text-gray-300"} /></>),
    },


  ])

  return (
    <>
      <div class="scrollbar-container">

        <RouterProvider router={router} />

      </div>
    </>
  );
}